/**
 * @desc 根据子库编号获取子库信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouse/childList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
